__webpack_require__.p = "/waiver_admin_app/";